import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const customerCompany = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        {
            title: '单位名称',
            dataIndex: 'companyName',
            key: 'companyName',
            scopedSlots: {
                customRender: 'copyInfoData',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.companyName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '单位类型',
            dataIndex: 'companyType',
            key: 'companyType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.companyType || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
        },
        {
            title: '单位地址',
            dataIndex: 'companyAddress',
            key: 'companyAddress',
            scopedSlots: {
                customRender: 'companyAddress'
            },
        },
        // {
        //     title: '法人',
        //     dataIndex: 'legalPerson',
        //     key: 'legalPerson',
        //     scopedSlots: {
        //         customRender: 'legalPerson'
        //     },
        // },
        {
            title: '启用状态',
            dataIndex: 'enabled',
            key: 'enabled',
            scopedSlots: {
                customRender: 'enabled'
            },
        },
        {
            title: '纳税登记编号',
            dataIndex: 'taxRegistrationNumber',
            key: 'taxRegistrationNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'copyInfoData'
            },
            filteredValue: filteredInfo.taxRegistrationNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
        },
        {
            title: '开户行&帐号',
            dataIndex: 'bankAccountNumber',
            key: 'bankAccountNumber',
            scopedSlots: {
                customRender: 'bankAccountNumber'
            }
        },
        // {
        //     title: '母公司',
        //     dataIndex: 'parentCompanyName',
        //     key: 'parentCompanyName',
        //     scopedSlots: {
        //         customRender: 'copyInfoData'
        //     }
        // },
        {
            title: '邮编',
            dataIndex: 'postalCode',
            key: 'postalCode',
            scopedSlots: {
                customRender: 'copyInfoData'
            }
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
